import { gql } from '@apollo/client'

export const BASE_QUESTION_PASSAGE_FIELDS = gql`
  fragment BaseQuestionPassageFields on QuestionPassageType {
    id
    title
    subject {
      id
      slug
      tabName
    }
    level
    content
    createdAt
    deletedAt
    isTemplate
    templateName
  }
`

export const BASE_QUESTION_PASSAGE_WITH_QUESTIONS_FIELDS = gql`
  ${BASE_QUESTION_PASSAGE_FIELDS}
  fragment BaseQuestionPassageWithQuestionsFields on QuestionPassageType {
    ...BaseQuestionPassageFields
    questions {
      id
      questionAsHtml
      answer {
        id
        textAsHtml
        isCorrect
        order
      }
      answerExplanationAsHtml
      questionCategory {
        id
      }
      order
    }
  }
`

export const GET_QUESTION_PASSAGES_LIST = gql`
  ${BASE_QUESTION_PASSAGE_FIELDS}
  query findAllQuestionPassages($params: QuestionPassageQueryInput! = {}) {
    findAllQuestionPassage(query: $params) {
      count
      items {
        ...BaseQuestionPassageFields
      }
    }
  }
`

export const GET_ONE_QUESTION_PASSAGE = gql`
  ${BASE_QUESTION_PASSAGE_WITH_QUESTIONS_FIELDS}
  query findOneQuestionPassage($params: String!) {
    findOneQuestionPassage(id: $params) {
      ...BaseQuestionPassageWithQuestionsFields
      history {
        updatedBy
        updatedAt
      }
    }
  }
`

export const UPDATE_QUESTION_PASSAGE = gql`
  ${BASE_QUESTION_PASSAGE_WITH_QUESTIONS_FIELDS}
  mutation updateCARSQuestion($params: UpdateCarsQuestionInput!) {
    updateCARSQuestion(updateCarsQuestionInput: $params) {
      ...BaseQuestionPassageWithQuestionsFields
    }
  }
`

export const UPDATE_QUESTION_PASSAGE_TITLE = gql`
  mutation updateCARSQuestionTitle($id: String!, $title: String) {
    updateCARSQuestion(updateCarsQuestionInput: { passage: { id: $id, title: $title } }) {
      id
      title
    }
  }
`

export const CREATE_QUESTION_PASSAGE = gql`
  ${BASE_QUESTION_PASSAGE_WITH_QUESTIONS_FIELDS}
  mutation createCARSQuestion($params: CreateQuestionPassageInput!) {
    createCARSQuestion(createCARSQuestionInput: $params) {
      ...BaseQuestionPassageWithQuestionsFields
    }
  }
`

export const REMOVE_QUESTION_PASSAGE = gql`
  mutation removeQuestionPassage($id: String!) {
    removeQuestionPassage(id: $id) {
      affected
      raw
    }
  }
`

export const GET_QUESTION_PASSAGE_LOCATIONS = gql`
  query findQuestionPassageLocation($id: String!) {
    findQuestionPassageLocation(id: $id) {
      id
      title
    }
  }
`

export const SEARCH_TEMPLATE_PASSAGE_QUESTION = gql`
  query searchTemplatePassageQuestion($searchString: String, $skip: Int, $take: Int) {
    searchTemplatePassageQuestion(searchString: $searchString, skip: $skip, take: $take) {
      count
      items {
        id
        title
        createdAt
        templateName
        isTemplate
      }
    }
  }
`
